module.exports = __webpack_public_path__ + "static/feature wall - 3-d1b099c557e9789ffa2aef077c1fe1bb.jpg";